import {
  createFeatureSelector,
  createSelector,
}                   from '@ngrx/store';
import { pluck }    from '~utils/common';
import { AppState } from './app.state';

const selectState = createFeatureSelector<AppState>('app');

export const selectColorMode = createSelector(selectState, pluck('colorMode'));

export const selectMaintenanceMode = createSelector(selectState, pluck('maintenanceMode'));

export const selectAccountUser = createSelector(selectState, pluck('accountUser'));

export const selectUserSettings = createSelector(selectState, pluck('userSettings'));

export const selectOffice = createSelector(selectState, pluck('office'));

export const selectNewBudgetAppEnabled = createSelector(selectState, pluck('newBudgetAppEnabled'));

export const selectClientBadgeCount = createSelector(selectState, pluck('clientBadgeCount'));

export const selectNotificationBadgeCount = createSelector(selectState, pluck('notificationBadgeCount'));

export const selectPaymentBadgeCount = createSelector(selectState, pluck('paymentBadgeCount'));

export const selectUnlinkedAccountsBadgeCount = createSelector(selectState, pluck('unlinkedAccountsBadgeCount'));

export const selectAccountsWithWarningBadgeCount = createSelector(selectState, pluck('accountsWithWarningBadgeCount'));

export const selectDocumentBadgeCount = createSelector(selectState, pluck('documentBadgeCount'));

export const selectCreateClientIsLoading = createSelector(selectState, pluck('createClientIsLoading'));

export const selectDocumentUpdating = createSelector(selectState, pluck('documentUpdating'));

export const selectDocumentDownloadingId = createSelector(selectState, pluck('documentDownloadingId'));

export const selectSelectingDocuments = createSelector(selectState, pluck('selectingDocuments'));

export const selectRenameDocumentIsLoading = createSelector(selectState, pluck('renameDocumentIsLoading'));

export const selectToggleDocumentHiddenIsLoadingId = createSelector(selectState, pluck('toggleDocumentHiddenIsLoadingId'));

export const selectToggleDocumentSharedIsLoadingId = createSelector(selectState, pluck('toggleDocumentSharedIsLoadingId'));

export const selectDeleteDocumentIsLoading = createSelector(selectState, pluck('deleteDocumentIsLoading'));

export const selectFetchingDocumentPaymentDataId = createSelector(selectState, pluck('fetchingDocumentPaymentDataId'));

export const selectPaymentAccounts = createSelector(selectState, pluck('paymentAccounts'));

export const selectPaymentClients = createSelector(selectState, pluck('paymentClients'));

export const selectPaymentDocumentType = createSelector(selectState, pluck('paymentDocumentType'));

export const selectPaymentDocumentUrl = createSelector(selectState, pluck('paymentDocumentUrl'));

export const selectGlobalBeneficiaries = createSelector(selectState, pluck('globalBeneficiaries'));

export const selectClientBeneficiaries = createSelector(selectState, pluck('clientBeneficiaries'));

export const selectGlobalBeneficiariesLoading = createSelector(selectState, pluck('globalBeneficiariesLoading'));

export const selectClientBeneficiariesLoading = createSelector(selectState, pluck('clientBeneficiariesLoading'));

export const selectPaymentSaving = createSelector(selectState, pluck('paymentSaving'));

export const selectPaymentInfoLoading = createSelector(selectState, pluck('paymentInfoLoading'));

export const selectBeneficiaryEditing = createSelector(selectState, pluck('beneficiaryEditing'));

export const selectDuplicatePaymentsType = createSelector(selectState, pluck('duplicatePaymentsType'));

export const selectDuplicatePaymentsLatestDate = createSelector(selectState, pluck('duplicatePaymentsLatestDate'));

export const selectViewDocumentUrl = createSelector(selectState, pluck('viewDocumentUrl'));

export const selectViewDocumentType = createSelector(selectState, pluck('viewDocumentType'));

export const selectFetchingDocumentAssignmentDataIds = createSelector(selectState, pluck('fetchingDocumentAssignmentDataIds'));

export const selectAssignDocumentClients = createSelector(selectState, pluck('assignDocumentClients'));

export const selectAssignDocumentType = createSelector(selectState, pluck('assignDocumentType'));

export const selectAssignDocumentUrl = createSelector(selectState, pluck('assignDocumentUrl'));

export const selectAssignDocumentIsLoading = createSelector(selectState, pluck('assignDocumentIsLoading'));

export const selectFetchingDocumentProcessingData = createSelector(selectState, pluck('fetchingDocumentProcessingData'));

export const selectProcessDocumentType = createSelector(selectState, pluck('processDocumentType'));

export const selectProcessDocumentUrl = createSelector(selectState, pluck('processDocumentUrl'));

export const selectXs2aInfoIsLoading = createSelector(selectState, pluck('xs2aInfoIsLoading'));

export const selectXs2aFinancialInstitutions = createSelector(selectState, pluck('xs2aFinancialInstitutions'));

export const selectAiarInfoIsLoading = createSelector(selectState, pluck('aiarInfoIsLoading'));

export const selectAiarInfo = createSelector(selectState, pluck('aiarInfo'));

export const selectCreateAiarIsLoading = createSelector(selectState, pluck('createAiarIsLoading'));

export const selectCreateAiarAuthorizationIsLoading = createSelector(selectState, pluck('createAiarAuthorizationIsLoading'));

export const selectAiarAuthorization = createSelector(selectState, pluck('aiarAuthorization'));

export const selectAiarAuthorizationError = createSelector(selectState, pluck('aiarAuthorizationError'));

export const selectCreateIsabelAuthorizationIsLoading = createSelector(selectState, pluck('createIsabelAuthorizationIsLoading'));

export const selectIsabelAuthorizationError = createSelector(selectState, pluck('isabelAuthorizationError'));
